import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "mb-3" }
const _hoisted_2 = { class: "input-group input-group-email" }
const _hoisted_3 = { class: "input-group" }
const _hoisted_4 = {
  key: 1,
  class: "messages"
}
const _hoisted_5 = {
  key: 0,
  class: "error text-danger",
  style: {"text-align":"justify"}
}
const _hoisted_6 = { style: {"text-align":"left"} }
const _hoisted_7 = {
  key: 1,
  class: "error text-danger",
  style: {"text-align":"justify"}
}
const _hoisted_8 = {
  class: "errors",
  key: "errors"
}
const _hoisted_9 = {
  key: 0,
  class: "error text-danger"
}
const _hoisted_10 = {
  key: 1,
  class: "error text-danger"
}
const _hoisted_11 = {
  key: 2,
  class: "error text-danger"
}
const _hoisted_12 = {
  key: 3,
  class: "upgradeInfo text-info d-flex flex-column"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = { class: "text-success" }
const _hoisted_16 = { key: 2 }
const _hoisted_17 = { key: 3 }
const _hoisted_18 = { class: "text-success" }
const _hoisted_19 = {
  class: "upgradeInfo text-info d-flex flex-column",
  key: "reg"
}
const _hoisted_20 = {
  key: 0,
  class: "purchasedPass"
}
const _hoisted_21 = { class: "purchasedPass" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 5,
  class: "upgradeInfo text-info d-flex flex-column"
}
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { key: 1 }
const _hoisted_26 = { class: "text-success" }
const _hoisted_27 = { key: 2 }
const _hoisted_28 = { class: "text-success" }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = { key: 5 }
const _hoisted_32 = { class: "text-success" }
const _hoisted_33 = { class: "d-flex flex-column justify-content-center align-items-center" }
const _hoisted_34 = {
  type: "submit",
  class: "registerButton noselect"
}
const _hoisted_35 = {
  class: "content",
  ref: "registerButton"
}
const _hoisted_36 = { class: "background absolute-fill" }
const _hoisted_37 = {
  key: 0,
  class: "label"
}
const _hoisted_38 = {
  key: 1,
  class: "label"
}
const _hoisted_39 = { class: "price" }
const _hoisted_40 = { class: "total" }
const _hoisted_41 = {
  key: 0,
  class: "result"
}
const _hoisted_42 = { class: "stroke" }
const _hoisted_43 = { class: "total" }
const _hoisted_44 = {
  key: 1,
  class: "total"
}

import LoadingSpin from "@/components/Common/LoadingSpin.vue";
import {default as templateRouter} from "@/router";
import {default as templateStore} from "@/store";

import {defineComponent} from 'vue'
import {PassProperties} from "@/components/RegistrationPage/Card/PassProperties";
import store from "@/store";
import axios from "axios";
import router from "@/router";
import {
    CheckInputDataInterface,
    UsedPassInterface
} from "@/components/RegistrationPage/Response/CheckInputData";

const __default__ = defineComponent({
    name: 'PaymentInfo',

    data(): {
        isLoading: boolean
        email: string
        lastInput: {
            promocode: string
            email: string
        },
        inputCheckTimeout: number | null
        inputCheckResult: CheckInputDataInterface | null
        promocode: string
        promocodeResult: {
            priceOff: number | null
            percentOff: number | null
        }
        data: {
            orderId: string
            signature: string
        }
        order: {
            totalAmount: number
            itemName: string
            itemQuantity: number
            itemAmount: number
        }
        errors: {
            passNoSell: boolean
            promocode: boolean
            promocodeEmail: boolean
            promocodeUsed: boolean
            needEmail: boolean
            badEmail: boolean
            badReferral: boolean
            takenEmail: boolean
            validation: {
                email: boolean
            }
        }
    } {
        return {
            isLoading: false,
            inputCheckResult: null,
            lastInput: {
                promocode: '',
                email: '',
            },
            email: '',
            inputCheckTimeout: null,
            promocode: '',
            promocodeResult: {
                priceOff: null,
                percentOff: null,
            },
            data: {
                orderId: '',
                signature: '',
            },
            order: {
                totalAmount: 0,
                itemName: '',
                itemQuantity: 0,
                itemAmount: 0,
            },
            errors: {
                validation: {
                    email: false,
                },

                passNoSell: false,
                needEmail: false,
                badEmail: false,
                badReferral: false,
                takenEmail: false,
                promocode: false,
                promocodeEmail: false,
                promocodeUsed: false,
            },
        }
    },

    computed: {
        selectedPass(): PassProperties | null
        {
            return store.state.selectedPass
        },

        maxLevel(): number
        {
            let level = 0
            store.state.passes.forEach((pass: PassProperties) => {
                level = Math.max(
                    level,
                    pass.level,
                )
            })

            return level
        },

        purchasedPass(): PassProperties | null
        {
            for (const pass of store.state.passes) {
                if (pass.code === this.inputCheckResult?.pass?.code) {
                    return pass
                }
            }

            return null
        },

        prices(): {
            originalPrice: number
            finalPrice: number
        } {
            if (!this.selectedPass) {
                return {
                    originalPrice: 0,
                    finalPrice: 0,
                }
            }

            const prices = {
                originalPrice: this.selectedPass.basicPrice,
                finalPrice: this.selectedPass.basicPrice,
            }

            let discount = 0

            // if (this.selectedPass.isPlayersChoice) {
            //     discount += 10
            // }

            const usedPass: UsedPassInterface | null = this.inputCheckResult?.pass ?? null
            if (usedPass) {
                prices.originalPrice = this.selectedPass.price - (this.purchasedPass?.basicPrice ?? 0)
                discount += (usedPass.referralOf || router.currentRoute.value.params.referralCode) ? 10 : 0
                discount += (usedPass.usedPromocode?.percentOff ?? this.inputCheckResult?.promocode?.percentOff) ?? 0
            } else {
                discount += router.currentRoute.value.params.referralCode ? 10 : 0
                discount += this.inputCheckResult?.promocode?.percentOff ?? 0
            }

            if (discount === 0 && this.selectedPass.isPlayersChoice) {
                discount += 10
            }

            prices.finalPrice = Math.max(1, Math.floor((prices.originalPrice * (100 - discount) / 100)));



            return prices
        }
    },

    watch: {
        purchasedPass: {
            handler(): void
            {
                this.togglePurchase()
            },
        },

        selectedPass: {
            handler(): void
            {
                this.togglePurchase()
            },
        },
    },

    mounted(): void
    {
        const button = this.$refs.registerButton
        if (button instanceof HTMLElement) {
            setTimeout(() => {
                button.classList.add('active')

                setInterval(() => {
                    button.classList.contains('maxOpen')
                        ? button.classList.remove('maxOpen')
                        : button.classList.add('maxOpen')
                }, 2000)
            }, 500)
        }

        this.email = (router.currentRoute.value.query.email || '').toString().toLowerCase().trim()
        this.checkInput()
    },

    methods: {
        togglePurchase(): void
        {
            if ((this.purchasedPass?.price ?? 0) >= (this.selectedPass?.price || 0)) {
                store.state.canPurchase = false
                return;
            }

            store.state.canPurchase = true
        },

        clearErrors(): void
        {
            this.errors.passNoSell = false

            this.errors.badReferral = false

            this.errors.validation.email = false
            this.errors.badEmail = false
            this.errors.needEmail = false
            this.errors.takenEmail = false

            this.errors.promocode = false
            this.errors.promocodeEmail = false
            this.errors.promocodeUsed = false
        },

        checkInput(): void
        {
            const promocode = this.promocode.trim()
            const email = this.email.trim()

            if (this.lastInput.promocode === promocode && this.lastInput.email === email) {
                return
            }

            this.isLoading = true
            this.clearErrors()

            if (this.inputCheckTimeout) {
                clearTimeout(this.inputCheckTimeout)
            }

            this.lastInput = {
                promocode: promocode,
                email: email,
            }

            const referral = router.currentRoute.value.params.referralCode || ''

            this.inputCheckTimeout = setTimeout(() => {
                axios
                    .get(
                        `/api/game-pass/v1/check?email=${email}&promocode=${promocode}&referral=${referral}`,
                    )
                    .then(result => {
                        this.isLoading = false
                        this.inputCheckResult = result.data.data
                        store.state.prices = result.data.data.prices
                    })
                    .catch(() => {
                        this.isLoading = false
                    })
            }, 500)
        },

        submit(): void
        {
            if (!store.state.canPurchase) {
                return
            }

            if (this.isLoading) {
                return
            }

            this.isLoading = true

            this.clearErrors()

            const email = this.email.trim()
            if (email === '') {
                this.errors.needEmail = true
                this.isLoading = false
                return
            }

            axios
                .post(
                    '/api/game-pass/v1/payment/robokassa/init',
                    {
                        email: email,
                        promocode: this.promocode.trim(),
                        pass: this.selectedPass?.code,
                        referral: router.currentRoute.value.params.referralCode ?? null,
                    },
                )
                .then(result => {
                    this.isLoading = false
                    window.location = result.data.data.payment_url
                })
                .catch(error => {
                    console.warn(error)
                    console.warn(error.code)
                    console.warn(error.response.status)
                    console.warn(error.response.data.errors)

                    switch (error.code) {
                        case 'ERR_BAD_REQUEST':
                            switch (error.response.status) {
                                case 400:
                                    if (error.response.data.errors.promocode) {
                                        switch (error.response.data.errors.promocode) {
                                            case 'This promocode was already used.':
                                                this.errors.promocodeUsed = true
                                                break

                                            case 'Promocode does not exist.':
                                                this.errors.promocode = true
                                                break

                                            case 'Promocode must match certain email.':
                                                this.errors.promocodeEmail = true
                                                break

                                            default:
                                                break
                                        }
                                    }

                                    if (error.response.data.errors.pass) {
                                        switch (error.response.data.errors.pass) {
                                            case 'No':
                                                this.errors.passNoSell = true
                                                break

                                            default:
                                                break
                                        }
                                    }

                                    if (error.response.data.errors.email) {
                                        switch (error.response.data.errors.email) {
                                            case 'This value should not be blank.':
                                                this.errors.badEmail = true
                                                break

                                            case 'This value is not a valid email address.':
                                                this.errors.validation.email = true
                                                break

                                            case 'User with this e-mail has already purchased a pass.':
                                                this.errors.takenEmail = true
                                                break

                                            default:
                                                break
                                        }
                                    }

                                    if (error.response.data.errors.referral) {
                                        switch (error.response.data.errors.referral) {
                                            case 'You are not trying to hack our referral code system, are you?':
                                                this.errors.badReferral = true
                                                break

                                            default:
                                                break
                                        }
                                    }
                                    break;

                                default:
                                    break;
                            }
                            break;

                        default:
                            break;
                    }

                    this.isLoading = false
                })
        },
    },
})


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.selectedPass)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["form", {
            mobile: _unref(templateStore).state.pageSize.width <= _unref(templateStore).state.mobileVersionThresholdWidth,
        }])
      }, [
        _cache[41] || (_cache[41] = _createElementVNode("img", {
          class: "smoke",
          src: `/img/page/landing/registration/misc/smoke.png`
        }, null, -1)),
        _createElementVNode("form", {
          onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.submit && _ctx.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _cache[8] || (_cache[8] = _createElementVNode("span", {
                class: "input-group-text",
                id: "inputGroupPrepend3"
              }, [
                _createElementVNode("i", { class: "bi bi-envelope-at" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: _normalizeClass(["form-control", {
                            'is-invalid': _ctx.errors.needEmail || _ctx.errors.validation.email || _ctx.errors.takenEmail,
                            'is-valid': _ctx.email.trim() !== '' && (!(_ctx.errors.needEmail || _ctx.errors.validation.email || _ctx.errors.badEmail || _ctx.errors.takenEmail))
                        }]),
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.checkInput && _ctx.checkInput(...args))),
                onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkInput && _ctx.checkInput(...args))),
                placeholder: "Твой e-mail",
                id: "validationEmail",
                "aria-describedby": "validationEmailFeedback",
                required: "",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.email) = $event))
              }, null, 34), [
                [_vModelText, _ctx.email]
              ])
            ]),
            _createElementVNode("div", _hoisted_3, [
              _cache[9] || (_cache[9] = _createElementVNode("span", {
                class: "input-group-text",
                id: "inputGroupPrepend3"
              }, [
                _createElementVNode("i", { class: "bi bi-magic" })
              ], -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control input-promocode",
                onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.checkInput && _ctx.checkInput(...args))),
                onKeyup: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.checkInput && _ctx.checkInput(...args))),
                placeholder: "Промокод",
                maxlength: "30",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.promocode) = $event))
              }, null, 544), [
                [_vModelText, _ctx.promocode]
              ])
            ]),
            (_ctx.isLoading)
              ? (_openBlock(), _createBlock(LoadingSpin, { key: 0 }))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  (_ctx.errors.badReferral)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _cache[15] || (_cache[15] = _createElementVNode("p", null, "Похоже, ты пытаешься использовать неработающую реферальную ссылку: скорее всего, её неправильно скопировали и обрезали последние символы в коде.", -1)),
                        _cache[16] || (_cache[16] = _createElementVNode("p", null, "Можно сделать следующее:", -1)),
                        _createElementVNode("ul", _hoisted_6, [
                          _cache[13] || (_cache[13] = _createElementVNode("li", null, "Обратиться к тому, кто дал тебе ссылку, и попросить проверить её корректность;", -1)),
                          _cache[14] || (_cache[14] = _createElementVNode("li", null, "Поискать другую реферальную ссылку;", -1)),
                          _createElementVNode("li", null, [
                            _cache[11] || (_cache[11] = _createTextVNode("Повторить регистрацию без реферальной ссылки (для этого ")),
                            _createVNode(_component_router_link, {
                              to: "/register",
                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clearErrors()))
                            }, {
                              default: _withCtx(() => _cache[10] || (_cache[10] = [
                                _createTextVNode("кликни сюда")
                              ])),
                              _: 1
                            }),
                            _cache[12] || (_cache[12] = _createTextVNode(")"))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.errors.passNoSell)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[17] || (_cache[17] = [
                        _createElementVNode("p", null, "Покупка новых пропусков отключена с началом ОБТ. Вы можете только проапгрейдить имеющийся пропуск.", -1)
                      ])))
                    : _createCommentVNode("", true),
                  (_ctx.inputCheckResult)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        (
                                    _ctx.inputCheckResult?.pass?.usedPromocode
                                    && _ctx.promocode.trim() !== ''
                                )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_9, " Использование нового промокода недоступно - при регистрации использовался другой промокод "))
                          : _createCommentVNode("", true),
                        (
                                    _ctx.inputCheckResult?.pass?.referralOf
                                    && _unref(templateRouter).currentRoute.value.params.referralCode
                                )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_10, " Использование новой реферальной ссылки недоступно - при регистрации использовалась другая реферальная ссылка "))
                          : (
                                    !_ctx.inputCheckResult?.pass?.usedPromocode
                                    && !_ctx.inputCheckResult?.promocode
                                    && _ctx.inputCheckResult?.request.promocode.toLowerCase() === _ctx.promocode.trim().toLowerCase()
                                    && _ctx.promocode.trim() !== '')
                            ? (_openBlock(), _createElementBlock("span", _hoisted_11, " Такого промокода нет "))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (!_ctx.inputCheckResult?.pass)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        (_ctx.selectedPass.isPlayersChoice)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, _cache[18] || (_cache[18] = [
                              _createTextVNode(" Пометка «Выбор игроков» даёт скидку "),
                              _createElementVNode("span", { class: "text-success" }, "10%", -1)
                            ])))
                          : _createCommentVNode("", true),
                        (_ctx.inputCheckResult?.promocode)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_14, [
                              _cache[19] || (_cache[19] = _createTextVNode(" Введённый промокод даёт скидку ")),
                              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.inputCheckResult.promocode.percentOff) + "%", 1)
                            ]))
                          : _createCommentVNode("", true),
                        (_unref(templateRouter).currentRoute.value.params.referralCode)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_16, _cache[20] || (_cache[20] = [
                              _createTextVNode(" Регистрация по реферальной ссылке даёт скидку "),
                              _createElementVNode("span", { class: "text-success" }, "10%", -1)
                            ])))
                          : _createCommentVNode("", true),
                        (
                                    (_ctx.selectedPass.isPlayersChoice ? 1 : 0)
                                    + (_ctx.inputCheckResult?.promocode ? 1 : 0)
                                    + (_unref(templateRouter).currentRoute.value.params.referralCode ? 1 : 0)
                                    > 1
                                )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_17, [
                              _cache[21] || (_cache[21] = _createTextVNode(" Суммарная скидка на покупку составляет ")),
                              _createElementVNode("span", _hoisted_18, _toDisplayString((_ctx.inputCheckResult?.promocode?.percentOff ?? 0)
                                            + (_unref(templateRouter).currentRoute.value.params.referralCode ? 10 : 0)
                                            + (_ctx.selectedPass.isPlayersChoice ? 10 : 0)) + "% ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.inputCheckResult && _ctx.purchasedPass)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        (_ctx.purchasedPass.level === _ctx.maxLevel)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                              _cache[23] || (_cache[23] = _createElementVNode("div", { style: {"text-decoration":"underline"} }, "У тебя максимально возможный уровень пропуска!", -1)),
                              _createElementVNode("div", null, [
                                _cache[22] || (_cache[22] = _createTextVNode(" На этот e-mail уже оформлен пропуск ")),
                                _createElementVNode("span", {
                                  style: _normalizeStyle([{"white-space":"nowrap"}, {color: _ctx.purchasedPass.labelColor}])
                                }, "«" + _toDisplayString(_ctx.purchasedPass.name) + "»", 5)
                              ])
                            ]))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createElementVNode("div", _hoisted_21, [
                                _cache[25] || (_cache[25] = _createElementVNode("div", { style: {"text-decoration":"underline"} }, "Доступен апгрейд!", -1)),
                                _createElementVNode("div", null, [
                                  _cache[24] || (_cache[24] = _createTextVNode(" На этот e-mail уже оформлен пропуск ")),
                                  _createElementVNode("span", {
                                    style: _normalizeStyle([{"white-space":"nowrap"}, {color: _ctx.purchasedPass.labelColor}])
                                  }, "«" + _toDisplayString(_ctx.purchasedPass.name) + "»", 5)
                                ])
                              ]),
                              (_ctx.selectedPass.price <= _ctx.purchasedPass.price)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _cache[26] || (_cache[26] = _createElementVNode("span", null, "Ты можешь проапгрейдиться до более высокоуровневого пропуска:", -1)),
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(templateStore).state.passes, (pass) => {
                                      return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: pass.code
                                      }, [
                                        (pass.level > _ctx.purchasedPass.level)
                                          ? (_openBlock(), _createElementBlock("div", {
                                              key: 0,
                                              class: "suggestegOption",
                                              onClick: ($event: any) => (_unref(templateStore).state.selectedPass = pass),
                                              style: _normalizeStyle({
                                                color: pass.labelColor,
                                            })
                                            }, " «" + _toDisplayString(pass.name) + "» ", 13, _hoisted_22))
                                          : _createCommentVNode("", true)
                                      ], 64))
                                    }), 128))
                                  ], 64))
                                : _createCommentVNode("", true)
                            ], 64))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.inputCheckResult?.pass)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                        (_ctx.selectedPass.isPlayersChoice)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_24, _cache[27] || (_cache[27] = [
                              _createTextVNode(" Пометка «Выбор игроков» даёт скидку "),
                              _createElementVNode("span", { class: "text-success" }, "10%", -1)
                            ])))
                          : _createCommentVNode("", true),
                        (_ctx.inputCheckResult.pass.usedPromocode)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_25, [
                              _cache[28] || (_cache[28] = _createTextVNode(" При регистрации был использован промокод, дающий скидку ")),
                              _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.inputCheckResult.pass?.usedPromocode?.percentOff) + "%", 1)
                            ]))
                          : (_ctx.inputCheckResult?.promocode)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                                _cache[29] || (_cache[29] = _createTextVNode(" Введённый промокод даёт скидку ")),
                                _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.inputCheckResult.promocode?.percentOff) + "%", 1)
                              ]))
                            : _createCommentVNode("", true),
                        (_ctx.inputCheckResult.pass.referralOf)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_29, _cache[30] || (_cache[30] = [
                              _createTextVNode(" При регистрации была использована реферальная ссылка, дающая скидку "),
                              _createElementVNode("span", { class: "text-success" }, "10%", -1)
                            ])))
                          : (_unref(templateRouter).currentRoute.value.params.referralCode)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_30, _cache[31] || (_cache[31] = [
                                _createTextVNode(" Регистрация по реферальной ссылке даёт скидку "),
                                _createElementVNode("span", { class: "text-success" }, "10%", -1)
                              ])))
                            : _createCommentVNode("", true),
                        (
                                    (_ctx.selectedPass.isPlayersChoice ? 1 : 0)
                                    + ((
                                        _ctx.inputCheckResult.pass.usedPromocode
                                        || _ctx.inputCheckResult.promocode
                                        ) ? 1 : 0)
                                    + ((
                                        _ctx.inputCheckResult.pass.referralOf
                                        || _unref(templateRouter).currentRoute.value.params.referralCode
                                        ) ? 1 : 0)
                                    > 1
                                )
                          ? (_openBlock(), _createElementBlock("span", _hoisted_31, [
                              _cache[32] || (_cache[32] = _createTextVNode(" Суммарная скидка на апгрейд составляет ")),
                              _createElementVNode("span", _hoisted_32, _toDisplayString((
                                                (
                                                    _ctx.inputCheckResult.pass.usedPromocode?.percentOff
                                                    ?? _ctx.inputCheckResult.promocode?.percentOff
                                                )
                                                ?? 0
                                            )
                                            + (
                                                (
                                                    _ctx.inputCheckResult.pass?.referralOf
                                                    || _unref(templateRouter).currentRoute.value.params.referralCode
                                                )
                                                    ? 10
                                                    : 0
                                            )
                                            + (_ctx.selectedPass.isPlayersChoice ? 10 : 0)) + "% ", 1)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_33, [
            _createElementVNode("button", _hoisted_34, [
              _createElementVNode("div", _hoisted_35, [
                _cache[35] || (_cache[35] = _createElementVNode("div", { class: "doorLeaf top" }, null, -1)),
                _cache[36] || (_cache[36] = _createElementVNode("div", { class: "doorLeaf bottom" }, null, -1)),
                _createElementVNode("div", _hoisted_36, [
                  (_ctx.purchasedPass)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                        _createElementVNode("span", null, [
                          _cache[33] || (_cache[33] = _createTextVNode(" Апгрейд до уровня ")),
                          _createElementVNode("span", {
                            class: "name",
                            style: _normalizeStyle([{"white-space":"nowrap"}, {color: _ctx.selectedPass.labelColor}])
                          }, "«" + _toDisplayString(_ctx.selectedPass.name) + "»", 5)
                        ])
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                        _createElementVNode("span", null, [
                          _cache[34] || (_cache[34] = _createTextVNode(" Купить пропуск ")),
                          _createElementVNode("span", {
                            class: "name",
                            style: _normalizeStyle([{"white-space":"nowrap"}, {color: _ctx.selectedPass.labelColor}])
                          }, "«" + _toDisplayString(_ctx.selectedPass.name) + "»", 5)
                        ])
                      ]))
                ])
              ], 512)
            ]),
            _createElementVNode("div", _hoisted_39, [
              (_ctx.purchasedPass && _unref(templateStore).state.prices[_ctx.selectedPass.code].upgradeFrom && _unref(templateStore).state.prices[_ctx.selectedPass.code].upgradeFrom[_ctx.purchasedPass.code])
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[37] || (_cache[37] = _createElementVNode("span", null, "Стоимость апгрейда: ", -1)),
                    _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(templateStore).state.prices[_ctx.selectedPass.code].upgradeFrom[_ctx.purchasedPass.code].toLocaleString('ru').replace(/\u00A0/g, ' ')) + " ₽", 1)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _cache[39] || (_cache[39] = _createElementVNode("span", null, "Стоимость: ", -1)),
                    (_ctx.selectedPass.basicPrice !== _unref(templateStore).state.prices[_ctx.selectedPass.code].buy)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                          _createElementVNode("div", _hoisted_42, [
                            _createElementVNode("span", null, _toDisplayString(_ctx.selectedPass.basicPrice.toLocaleString('ru').replace(/\u00A0/g, ' ')) + " ₽", 1),
                            _cache[38] || (_cache[38] = _createElementVNode("div", { class: "line" }, null, -1))
                          ]),
                          _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(templateStore).state.prices[_ctx.selectedPass.code].buy.toLocaleString('ru').replace(/\u00A0/g, ' ')) + " ₽", 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_44, _toDisplayString(_unref(templateStore).state.prices[_ctx.selectedPass.code].buy.toLocaleString('ru').replace(/\u00A0/g, ' ')) + " ₽", 1))
                  ], 64))
            ]),
            _cache[40] || (_cache[40] = _createElementVNode("span", { class: "emailInfo text-secondary" }, "На этот email ты получишь письмо о начале ЗБТ.", -1))
          ], 512), [
            [_vShow, _unref(templateStore).state.canPurchase && !_ctx.isLoading]
          ])
        ], 32)
      ], 2))
    : _createCommentVNode("", true)
}
}

})